import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlueprintPage = lazy(() => import('../pages/blueprint/page'));
const MeatMechanicPage = lazy(() => import('../pages/meat-mechanic/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blueprint-performance',
    element: <BlueprintPage />,
  },
  {
    path: '/meat-mechanic',
    element: <MeatMechanicPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;